import {Component} from '@angular/core';

@Component({
  selector: 'maglive-spinner',
  templateUrl: './spinner.component.html'
})
export class SpinnerComponent {
}
